const s = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3,
  silent: 4
};
let t = "error";
const g = (e) => s[e] >= s[t] && t !== "silent", r = (e, o, l) => {
  if (g(e)) {
    const n = `${(/* @__PURE__ */ new Date()).toISOString()} [${e.toUpperCase()}]: ${l || ""}`;
    typeof o == "object" ? console.log(n, JSON.stringify(o, null, 2)) : console.log(n, o);
  }
}, c = {
  set level(e) {
    t = e;
  },
  get level() {
    return t;
  },
  debug: (e, o) => r("debug", e, o),
  info: (e, o) => r("info", e, o),
  warn: (e, o) => r("warn", e, o),
  error: (e, o) => r("error", e, o)
};
export {
  c as logger
};
//# sourceMappingURL=index.js.map
